import React from 'react';
import styled from "styled-components";

const FormHint = styled.p`
  margin: 7px 7px 14px 7px;
  line-height: 1.4em;
  width: 100%;
  font-size: 0.8em;
`;

export default FormHint;